import React from 'react';
import { useSelector } from 'react-redux';
import { CasesForTheDayColumn } from './TimelineCaseColumn.styled';
import Order from 'src/pages/home/component/orders/order/Order';

const TimelineCaseColumn = (props) => {
    const orders = useSelector(
        (state) => state.ordersReducer.cardData.orderData
    );
    const columnDate = new Date(new Date(props.value).setHours(0, 0, 0, 0));
    const updatedOrders = (orders || []).map((order) => {
        return {
            ...order,
            updatedSurgeryDate: new Date(order.surgeryStartDate),
            // surgeryStartDate: new Date(order.surgeryStartDate),
        };
    });

    return (
        <CasesForTheDayColumn value={props.value}>
            {updatedOrders
                .filter(
                    (order) =>
                        order.updatedSurgeryDate.toDateString() ===
                        columnDate.toDateString()
                )
                .map((order, index) => {
                    return (
                        <div className="week-view-cards" key={index}>
                            <Order
                                key={order.myCaseRef}
                                {...order}
                                className={'week-view'}
                            />
                        </div>
                    );
                })}
        </CasesForTheDayColumn>
    );
};

export default TimelineCaseColumn;
